var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["box", { faulty: this.faulty }] }, [
    _c("div", { class: _vm.titleClasses }, [
      _c("div", [
        _vm.toggleable
          ? _c(
              "a",
              {
                staticClass: "d-inline-block",
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.showContent = !_vm.showContent
                  }
                }
              },
              [
                _c("Icon", {
                  attrs: {
                    icon: "triangle-right",
                    rotate: _vm.showContent ? 90 : 0,
                    color: "red"
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v("\n\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t"),
        _vm.tooltip
          ? _c(
              "span",
              {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip.html",
                    modifiers: { html: true }
                  }
                ],
                staticClass: "ml-2",
                attrs: { title: _vm.tooltip }
              },
              [_c("Icon", { attrs: { icon: "info" } })],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.editable
        ? _c("div", { staticClass: "actions" }, [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.$emit("edit")
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "edit", color: "red" } })],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: ["content", { "d-none": !_vm.showContent }] },
      [
        _vm.hasInfoTopSlot
          ? _c("div", { staticClass: "info-top" }, [_vm._t("info-top")], 2)
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default"),
        _vm._v(" "),
        _vm.hasInfoSlot
          ? _c("div", { staticClass: "info" }, [_vm._t("info")], 2)
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }